import { render, staticRenderFns } from "./PileLocalUnitProject.vue?vue&type=template&id=03964aea"
import script from "./PileLocalUnitProject.vue?vue&type=script&lang=js"
export * from "./PileLocalUnitProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports